export default __webpack_public_path__ + "static/callout-tubes-f93a5dbc8f8dd253f1b60b7896abd8d6.png";